import React from 'react';
import { Howl, Howler } from 'howler';
import { IoMusicalNotes } from 'react-icons/io5';
import { MdMusicOff } from 'react-icons/md';
import Music from '../assets/Music.mp3';
import './Audio.css';

/* Controller condiviso: il componente è montato due volte (navbar desktop e
   menu mobile), ma la musica è una sola e le icone restano sincronizzate. */
let sound = null;
let desired = true; // intenzione: musica accesa finché l'utente non la spegne
let isPlaying = false;
let autoplayArmed = false;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(isPlaying));

const getSound = () => {
  if (!sound) {
    sound = new Howl({ src: [Music], loop: true, volume: 0 });
  }
  return sound;
};

const fadeIn = () => {
  const s = getSound();
  if (!s.playing()) s.play();
  s.fade(s.volume(), 0.8, 900);
  isPlaying = true;
  notify();
};

const fadeOut = () => {
  const s = getSound();
  s.fade(s.volume(), 0, 600);
  setTimeout(() => {
    if (!desired) s.pause();
  }, 600);
  isPlaying = false;
  notify();
};

const toggleMusic = () => {
  desired = !isPlaying;
  if (desired) fadeIn();
  else fadeOut();
};

const armAutoplay = () => {
  if (autoplayArmed) return;
  autoplayArmed = true;

  getSound();
  const ctx = Howler.ctx;
  if (ctx && ctx.state === 'running') {
    fadeIn();
    return;
  }

  // Autoplay bloccato dal browser: parte alla prima interazione qualsiasi
  const events = ['pointerdown', 'keydown', 'touchstart', 'wheel'];
  const onFirstInteraction = (evt) => {
    // Se la prima interazione è sul bottone musica, lascia decidere al toggle
    if (evt.target && evt.target.closest && evt.target.closest('.app__music')) return;
    events.forEach((e) => window.removeEventListener(e, onFirstInteraction));
    if (desired && !isPlaying) fadeIn();
  };
  events.forEach((e) => window.addEventListener(e, onFirstInteraction, { passive: true }));
};

const Audio = () => {
  const [playing, setPlaying] = React.useState(isPlaying);

  React.useEffect(() => {
    listeners.add(setPlaying);
    armAutoplay();
    return () => listeners.delete(setPlaying);
  }, []);

  return (
    <button
      type="button"
      className={`app__music ${playing ? 'app__music--playing' : ''}`}
      onClick={toggleMusic}
      aria-label={playing ? 'Ferma la musica / Stop music' : 'Ascolta la musica / Play music'}
      title={playing ? 'Ferma la musica' : 'Musica di sottofondo'}
    >
      {playing ? <IoMusicalNotes /> : <MdMusicOff />}
    </button>
  );
};

export default Audio;
